var core = module.exports = { version: '2.6.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
